import {ExclamationIcon} from '@heroicons/react/outline';
import React, {useState} from 'react';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import Button from '@/components/common/Button';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import ActivationModal from '@/components/Modals/ActivationModal';

import type {DeactivateAccountProps} from './types';

const DeactivateAccount: React.FC<
  React.PropsWithChildren<DeactivateAccountProps>
> = ({user, type = 'user'}) => {
  const [isActivationModalOpen, setIsActivationModalOpen] = useState(false);

  const toggleActivationModal = () =>
    setIsActivationModalOpen(!isActivationModalOpen);

  return (
    <React.Fragment>
      {/* Every account type is deactivated through the same endpoint. */}
      <PermissionsProvider permission={AfriexAdminPermission.UserDeactivate}>
        <div className="px-3 pt-3 mt-8">
          <h3 className="flex items-center gap-2 font-semibold text-failed-500 mb-2">
            {'Danger Zone'.toLocaleUpperCase()}{' '}
            <ExclamationIcon className="w-6 h-6 text-failed-500" />
          </h3>
          <hr className="mb-5 dark:border-dark-borderMid" />

          <div>
            <p className="text-gray-500 dark:text-gray-300">
              {user.isDeactivated
                ? 'Activating a user account gives them access to all Afriex products and services.'
                : 'Deactivating a user account removes access to all Afriex products and services for the user.'}
            </p>

            <div className="flex md:justify-end mt-6 gap-6">
              <Button
                colorScheme={user.isDeactivated ? 'green' : 'orange'}
                onClick={toggleActivationModal}
                className="h-10"
              >
                {user.isDeactivated ? 'Activate' : 'Deactivate'} Account
              </Button>
            </div>
          </div>
        </div>
      </PermissionsProvider>

      <ActivationModal
        isOpen={isActivationModalOpen}
        onClose={() => setIsActivationModalOpen(false)}
        user={user}
        type={type}
      />
    </React.Fragment>
  );
};

export default DeactivateAccount;
